import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator, ArrowRight, Sparkles } from 'lucide-react';

const NisanHesaplayiciBanner = () => {
  const IMAGE_URL =
    'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=520&h=620&q=85';

  return (
    <section
      className="relative py-12 sm:py-16 overflow-hidden"
      data-testid="nisan-hesaplayici-banner"
    >
      {/* Soft decorative backdrop */}
      <div className="absolute inset-0 bg-gradient-to-br from-rose-50 via-white to-pink-50" aria-hidden="true" />
      <div
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 10% 20%, rgba(244, 114, 182, 0.18) 0%, transparent 40%), radial-gradient(circle at 90% 80%, rgba(236, 72, 153, 0.12) 0%, transparent 45%)'
        }}
        aria-hidden="true"
      />

      <div className="relative container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-[2rem] sm:rounded-[2.5rem] shadow-xl shadow-rose-100/60 border border-rose-100/60 overflow-hidden">
            <div className="grid md:grid-cols-[260px_1fr] gap-0 items-stretch">
              {/* Visual side */}
              <div className="hidden md:block relative bg-gradient-to-br from-rose-100 to-pink-50">
                <img
                  src={IMAGE_URL}
                  alt="Nişan maliyeti hesaplama"
                  loading="lazy"
                  width="260"
                  height="500"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div
                  className="absolute inset-0 bg-gradient-to-t from-rose-900/25 via-rose-900/5 to-transparent"
                  aria-hidden="true"
                />
                {/* Floating calc badge */}
                <div className="absolute bottom-5 left-5 right-5 rounded-2xl bg-white/95 backdrop-blur ring-1 ring-white/60 shadow-lg px-4 py-3 flex items-center gap-3">
                  <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-rose-500 to-pink-600 flex items-center justify-center shadow-md">
                    <Calculator className="h-5 w-5 text-white" strokeWidth={2.4} />
                  </div>
                  <div className="min-w-0">
                    <div className="text-[10.5px] font-bold uppercase tracking-[0.14em] text-rose-600">
                      Ücretsiz Araç
                    </div>
                    <div className="text-[13px] font-semibold text-gray-900 truncate">
                      Bütçe hesaplayıcı
                    </div>
                  </div>
                </div>
              </div>

              {/* Content side */}
              <div className="px-6 sm:px-10 py-10 sm:py-12">
                <div className="mb-3">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-rose-50 text-rose-700 text-xs font-semibold uppercase tracking-wider border border-rose-100">
                    <Sparkles className="h-3 w-3" strokeWidth={2.4} />
                    Yeni · 2026
                  </span>
                </div>

                <h2 className="font-display text-2xl sm:text-3xl md:text-[2rem] font-semibold text-gray-900 leading-[1.15] tracking-tight">
                  Nişanınızın Maliyeti{' '}
                  <span className="italic text-rose-600" style={{ fontStyle: 'italic', fontWeight: 400 }}>
                    Ne Kadar?
                  </span>
                </h2>
                <p className="mt-3 text-gray-600 text-base sm:text-lg leading-relaxed">
                  Kişi sayısı, şehir ve tarzınıza göre <strong>2026 güncel fiyatlarıyla</strong>{' '}
                  bütçenizi 60 saniyede hesaplayın.
                  <span className="block mt-1 text-gray-500 text-sm">
                    Salon, ikram, yüzük, kıyafet, fotoğraf — tüm kalemler tek yerde.
                  </span>
                </p>

                {/* CTA */}
                <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                  <Link
                    to="/nisan-maliyeti-hesaplama"
                    className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-xl bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white font-semibold text-base shadow-lg shadow-rose-200 hover:shadow-xl hover:shadow-rose-300 transition-all"
                    data-testid="nisan-hesaplayici-cta"
                  >
                    Bütçemi Hesapla
                    <ArrowRight className="w-5 h-5" strokeWidth={2.4} />
                  </Link>
                  <Link
                    to="/nisan-maliyeti-hesaplama"
                    className="hidden sm:inline-flex items-center gap-1 text-[13px] font-semibold text-gray-600 hover:text-gray-900 underline underline-offset-4 decoration-gray-300"
                  >
                    Detaylı örnek dökümü gör
                  </Link>
                </div>

                <p className="mt-4 text-xs text-gray-500">
                  <span className="font-semibold text-gray-700">Tamamen ücretsiz.</span>{' '}
                  Bilgileriniz KVKK kapsamında korunur.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NisanHesaplayiciBanner;
